/* eslint-disable sonarjs/no-duplicate-string */
import React from 'react';
import { PLAYERS_ID } from '../../../../constants';
import TennisMatchPointsSequence from './TennisMatchPointsSequence';

const TennisMatchPointsRow = ({
  gameHistory,
  hasWinningPlayer,

}) => {
  const {
    playerOneGamesScore, playerTwoGamesScore,
    servingPlayer, lostServe, winningPlayer,
  } = gameHistory;
  return (
    <div className="tennisDetails__row">
      <div className="tennisDetails__info">

        <div className="tennisDetails__info-serve text-right">
          {(servingPlayer === PLAYERS_ID.PLAYER_1 && lostServe) && (<div className="tennisDetails__label tennisDetails__label--serve">Lost serve</div>)}
        </div>

        {servingPlayer === PLAYERS_ID.PLAYER_1 ? (
          <div className="tennisDetails__info-icon"><i className="icon-tennis-ball" /></div>
        )
          : <div className="tennisDetails__info-icon" />}

        <div className="tennisDetails__info-score">
          <span className={`${winningPlayer === PLAYERS_ID.PLAYER_1 ? 'clr-primary' : ''}`}>{playerOneGamesScore}</span>
          {' '}
          <span>-</span>
          {' '}
          <span className={`${winningPlayer === PLAYERS_ID.PLAYER_2 ? 'clr-primary' : ''}`}>{playerTwoGamesScore}</span>
        </div>

        {servingPlayer === PLAYERS_ID.PLAYER_2 ? (
          <div className="tennisDetails__info-icon"><i className="icon-tennis-ball" /></div>
        )
          : <div className="tennisDetails__info-icon" />}

        <div className="tennisDetails__info-serve text-left">
          {(servingPlayer === PLAYERS_ID.PLAYER_2 && lostServe) && (<div className="tennisDetails__label tennisDetails__label--serve">Lost serve</div>)}
        </div>

      </div>
      <div className="tennisDetails__txt">
        <span className="tennisDetails__txt-score">
          <TennisMatchPointsSequence
            gameHistory={gameHistory}
            hasWinningPlayer={hasWinningPlayer}
          />
        </span>
      </div>
    </div>
  );
};

export default TennisMatchPointsRow;
